import { createContext } from 'react';
import type { ThemeKey } from '@/styles/themes';

export type ThemeMode = 'light' | 'dark' | 'system';
export type ResolvedMode = 'light' | 'dark';

export interface ThemeContextValue {
  /** The user's chosen mode, including 'system'. */
  mode: ThemeMode;
  /** The concrete mode currently applied to the document. */
  resolvedMode: ResolvedMode;
  theme: ThemeKey;
  setMode: (mode: ThemeMode) => void;
  setTheme: (theme: ThemeKey) => void;
  /** Flip between light and dark based on what's currently showing. */
  toggleMode: () => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
